<template>
  <div class="course-package">
    <div class="title">
      <label>课程套餐</label>
      <i v-if="max > 0" @click="showPopup">{{
        selectedCourses && selectedCourses.length > 0 ? '重选' : '选择'
      }}</i>
    </div>

    <div class="courses">
      <div
        v-for="(item, index) in courseList"
        :key="index"
        class="select-course"
      >
        <p class="org-name">{{ item.businessName }}</p>
        <p class="course-name">
          <span v-for="(child, i) in item.detail" :key="i">{{ child }}</span>
        </p>
      </div>
    </div>

    <van-popup v-model="show" round @close="close" position="bottom">
      <div class="popup-wrapper">
        <div class="header">
          <p>
            选择课程套餐<i>（必选{{ max }}个）</i>
          </p>
          <img
            @click="
              () => {
                show = false
              }
            "
            src="https://test-1251601690.image.myqcloud.com/45d24c03-e6c6-45d2-b7de-29c91f47d1c8"
          />
        </div>
        <ul>
          <li
            v-for="(item, index) in courses"
            :key="index"
            @click="clickItem(item)"
          >
            <img :src="getImage(item)" />
            <div class="detail">
              <p>{{ item.businessName }}</p>
              <p>{{ item.courseName }}</p>
              <p>课时：{{ item.courseHour }}</p>
            </div>
          </li>
        </ul>
        <div
          class="confirm menu_wkBox_back_box"
          :class="{ full: selectCourseTmp.length < max }"
          @click="confirm"
        >
          <p>确定</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
export default {
  props: {
    courses: {
      type: Array,
      default() {
        return []
      }
    },
    selectedCourses: {
      type: Array,
      default() {
        return []
      }
    },
    max: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      selectCourseTmp: [],
      isConfirm: false
    }
  },
  mounted() {
    if (this.max === 0) {
      //默认全部选中了
      this.$emit('update:selectedCourses', this.courses)
    }
  },
  computed: {
    courseList() {
      const courseList = []
      const courses = this.max === 0 ? this.courses : this.selectedCourses
      for (let index = 0; index < courses.length; index++) {
        const element = courses[index]
        const sameObj = courseList.find(
          i => i.businessId === element.businessId
        )
        if (sameObj) {
          sameObj.detail = [
            ...sameObj.detail,
            `${element.courseName} (${element.courseHour}课时)`
          ]
        } else {
          element.detail = [`${element.courseName} (${element.courseHour}课时)`]
          courseList.push(element)
        }
      }
      return courseList
    }
  },
  methods: {
    showPopup() {
      this.show = true
    },
    clickItem(item) {
      const select = this.selectCourseTmp.find(
        i => i.courseName === item.courseName
      )
      if (select) {
        this.selectCourseTmp = this.selectCourseTmp.filter(
          i => i.courseName !== item.courseName
        )
      } else {
        if (this.selectCourseTmp.length >= this.max) {
          this.$$toast(`最多选择${this.max}门课程`)
          return
        }
        this.selectCourseTmp = [...this.selectCourseTmp, item]
      }
    },
    getImage(item) {
      const select = this.selectCourseTmp.find(
        i => i.courseName === item.courseName
      )
      return select
        ? require('@/assets/images/icon-select.png')
        : require('@/assets/images/icon-normal.png')
    },
    confirm() {
      if (this.selectCourseTmp.length < this.max) {
        this.$$toast(`请选择${this.max}门课程`)
        return
      }
      this.show = false
      this.isConfirm = true
      this.$emit('update:selectedCourses', this.selectCourseTmp)
    },
    close() {
      if (!this.isConfirm) {
        this.selectCourseTmp = this.selectedCourses
      }
      this.isConfirm = false
    }
  },
  components: {
    [Popup.name]: Popup
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.course-package {
  background-color: white;
  padding: 0 rem(24px);
  overflow: hidden;
  line-height: normal;

  .title {
    height: rem(96px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    label {
      color: #262626ff;
      font-size: rem(26px);
    }
    i {
      color: #999999;
      font-size: rem(26px);
      display: flex;
      align-items: center;
      &::after {
        content: '';
        margin-left: rem(23px);
        width: rem(20px);
        display: inline-block;
        height: rem(20px);
        background: url(~@/assets/images/icon-箭头@2x.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .courses {
    .select-course {
      &:last-child {
        margin-bottom: rem(32px);
      }
      margin-bottom: rem(16px);
      .org-name {
        color: #666;
        font-size: rem(24px);
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: rem(6px);
          min-width: rem(6px);
          margin-right: rem(12px);
          height: rem(6px);
          border-radius: 50%;
          background-color: #999;
          display: inline-block;
        }
      }
      .course-name {
        margin-top: rem(8px);
        color: #999;
        display: flex;
        flex-direction: column;
        font-size: rem(24px);
      }
    }
  }
}
.popup-wrapper {
  position: relative;
  overflow: hidden;
  padding: 0 rem(24px);
  .header {
    display: flex;
    p {
      color: #121212;
      font-weight: 500;
      margin-top: rem(32px);
      flex: 1;
      font-size: rem(36px);
      i {
        color: #999999ff;
        font-size: rem(24px);
      }
    }
    img {
      margin-top: rem(24px);
      width: rem(38px);
      height: rem(38px);
    }
  }
  ul {
    margin-top: rem(12px);
    max-height: 80vh;
    padding-bottom: rem(150px);
    overflow: hidden;
    overflow-y: scroll;
    li {
      margin-top: rem(20px);
      border-radius: 16px;
      padding: rem(25px) rem(20px) rem(20px) rem(30px);
      background: #f4f4f4ff;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: rem(30px);
      }
      img {
        width: rem(44px);
        height: rem(44px);
      }
      .detail {
        margin-left: rem(30px);
        :nth-child(1) {
          color: #333;
          font-weight: 600;
          font-size: rem(28px);
        }
        :nth-child(2) {
          color: #666;
          margin-top: rem(10px);
          font-size: rem(26px);
        }
        :nth-child(3) {
          color: #333;
          margin-top: rem(20px);
          font-size: rem(28px);
        }
      }
    }
  }
  .confirm {
    height: rem(100px);
    position: fixed;
    background-color: white;
    box-sizing: content-box;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 rem(24px);
    padding-top: rem(10px);
    p {
      border-radius: rem(40px);
      height: rem(80px);
      line-height: rem(80px);
      text-align: center;
      color: #ffffff;
      font-size: rem(32px);
      background: linear-gradient(270deg, #ff5900ff 0%, #ff8800ff 100%);
    }
  }
  .full {
    p {
      background: #999;
    }
  }
}
/deep/.van-popup__close-icon {
  color: #262626;
}
</style>
